"use client";

import React from "react";
import { Upload, User, Truck, ChevronRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const steps = [{
  icon: Upload,
  title: "Aderência de Soluções",
  description: "Validamos se as soluções Linx atendem plenamente aos processos e demandas específicas da sua operação comercial."
}, {
  icon: User,
  title: "Implantação e Treinamento",
  description: "Executamos a configuração técnica e treinamos sua equipe para extrair o máximo potencial do novo sistema de gestão."
}, {
  icon: Truck,
  title: "Acompanhamento e Suporte",
  description: "Monitoramos sua operação e oferecemos suporte especializado para garantir estabilidade e evolução constante do negócio."
}];
export default function JornadaDoPedido() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="48783" id="nossa-metodologia-de-entrega" ref={ref} className="bg-background py-24 w-full relative overflow-hidden">
      <div className="container mx-auto px-4 max-w-7xl">
        {}
        <div className={cn("text-center mb-16 transition-all duration-700 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <h2 className="font-sans text-4xl md:text-5xl font-bold text-foreground mb-4 tracking-tight">
            Como Transformamos sua Gestão
          </h2>
          <p className="font-sans text-lg text-muted-foreground max-w-2xl mx-auto">
            Entenda o passo a passo da nossa metodologia de entrega, desde a análise inicial até o suporte contínuo da sua operação.
          </p>
        </div>

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 relative">
          {steps.map((step, index) => {
          const isLast = index === steps.length - 1;
          const Icon = step.icon;
          return <React.Fragment key={index}>
                {}
                <div data-index={index} className={cn("flex flex-col items-center text-center flex-1 max-w-sm transition-all duration-700 ease-out delay-100", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")} style={{
              transitionDelay: `${index * 200}ms`
            }}>
                  <div className="mb-6 p-4 rounded-full bg-primary/10 shadow-lg border border-white/10 backdrop-blur-sm">
                    <Icon className="size-12 text-primary" strokeWidth={1.5} />
                  </div>
                  <h4 className="font-sans text-2xl font-bold text-foreground mb-3">
                    {step.title}
                  </h4>
                  <p className="font-sans text-base text-foreground/80 leading-relaxed">
                    {step.description}
                  </p>
                </div>

                {}
                {!isLast && <div className={cn("hidden md:flex items-center justify-center text-muted-foreground/30 shrink-0 transition-all duration-700 delay-300", isVisible ? "opacity-100" : "opacity-0")}>
                    <ChevronRight className="size-12" strokeWidth={1} />
                  </div>}
              </React.Fragment>;
        })}
        </div>
      </div>
    </section>;
}